import Logo from "@/public/logo-small.svg";
import { cn } from "@workspace/ui/lib/utils";
import { FC, HTMLAttributes, PropsWithChildren } from "react";

export const BrowserTab: FC<
  PropsWithChildren<HTMLAttributes<HTMLDivElement> & { title?: string }>
> = ({ children, className, title = "Yolk Explainer", ...props }) => {
  return (
    <div
      className={cn(
        "flex flex-col gap-[18px] rounded-[24px] bg-[#f3e4c9] p-2.5 pt-[18px] w-full max-w-[1120px]",
        className,
      )}
      {...props}
    >
      <div className="flex items-center pl-[22px] gap-6 w-full">
        <div className="flex items-center gap-3">
          <span className="size-4 bg-[#ed5931] rounded-full" />
          <span className="size-4 bg-[#FFAD62] rounded-full" />
          <span className="size-4 bg-[#C9B829] rounded-full" />
        </div>
        <div className="flex items-center h-11 w-full max-w-[178px] bg-white rounded-[10px] gap-2.5 px-3">
          <Logo />
          <span className="text-black font-semibold">{title}</span>
        </div>
      </div>
      <div className="relative flex aspect-video w-full bg-white rounded-[20px] border border-[#e3b8c4] overflow-hidden">
        {children}
      </div>
    </div>
  );
};
